import { LargeCheckboxInput, cn } from '@baseball-near-you/ui';
import { Handedness } from './PersonalUserForms/PersonalUserHandednessForm';

export function LeftRightInputs({
  label,
  value,
  onChange,
  className,
  hint,
}: {
  label: string;
  value: Handedness;
  onChange: (value: Handedness | null) => void;
  className?: string;
  hint?: string;
}) {
  return (
    <div className={cn('flex flex-col gap-y-2', className)}>
      <p className="title">
        {label}{' '}
        <span className="font-bold text-gray-500">
          ({(value ?? 'none').toLowerCase()})
        </span>
      </p>
      <div className="flex w-full gap-x-2">
        <LargeCheckboxInput
          id={`${label}-Left-checkbox`}
          label="Left"
          onChange={(e) => {
            //   if none are clicked, left
            // if right is clicked, switch
            // if switch is clicked, right
            // if left is clicked, null
            if (e.target.checked) {
              if (value === Handedness.Right) {
                // check both
                onChange(Handedness.Switch);
              } else {
                // check left
                onChange(Handedness.Left);
              }
            } else {
              if (value === Handedness.Switch) {
                onChange(Handedness.Right);
              } else {
                onChange(null);
              }
            }
          }}
          checked={value === Handedness.Left || value === Handedness.Switch}
        />
        <LargeCheckboxInput
          id={`${label}-Right-checkbox`}
          label="Right"
          onChange={(e) => {
            //   if none are clicked, left
            // if right is clicked, switch
            // if switch is clicked, right
            // if left is clicked, null
            if (e.target.checked) {
              if (value === Handedness.Left) {
                // check both
                onChange(Handedness.Switch);
              } else {
                // check right
                onChange(Handedness.Right);
              }
            } else {
              if (value === Handedness.Switch) {
                onChange(Handedness.Left);
              } else {
                onChange(null);
              }
            }
          }}
          checked={value === Handedness.Right || value === Handedness.Switch}
        />
      </div>
      {!!hint && <p className="text-gray-400 text-xs">{hint}</p>}
    </div>
  );
}
